<template>
  <div>
    <van-nav-bar
      ref="headerBarRef"
      class="custom-header-bar"
      v-bind="omit(props, ['path', 'mode', 'safeAreaInsetTop'])"
      @click-right="onClickRight"
    >
      <template #left>
        <slot name="left">
          <div class="flex-start" @click="goBack">
            <van-icon class="fs_48" name="arrow-left" v-if="leftArrow" />
            <span class="fs_42 ml_15" style="line-height: 1.2">{{ leftText }}</span>
          </div>
        </slot>
      </template>
      <template #right>
        <slot name="right">
          <span class="fs_42 ml_15" :style="{ color: rightColor, 'line-height': '1.2' }">{{ rightText }}</span>
        </slot>
      </template>
    </van-nav-bar>
    <div class="van-safe-area-top" style="height: var(--header-height)"></div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useElementSize } from '@vueuse/core';
import { useAppStore } from '@star/stores';
import { emitter, EventEnum } from '@star/utils';
import { omit } from 'lodash-es';

type Props = {
  path?: string;
  title?: string;
  mode?: 'popup' | 'page';
  zIndex?: number;
  leftArrow?: boolean;
  leftText?: string;
  safeAreaInsetTop?: boolean;
  fixed?: boolean;
  rightText?: string;
  rightColor?: string;
};

const props = withDefaults(defineProps<Props>(), {
  zIndex: 1000,
  leftArrow: true,
  safeAreaInsetTop: true,
  fixed: true,
  mode: 'page',
  rightColor: '#3f4b4d',
});

const emit = defineEmits(['click-left', 'click-right']);

const appStore = useAppStore();
const router = useRouter();
const headerBarRef = ref<any>();
const { height: headerHeight } = useElementSize(headerBarRef);

const goBack = () => {
  if (props.mode === 'page') {
    props.path ? router.push(props.path) : router.back();
  } else {
    emit('click-left');
  }
};

const onClickRight = () => {
  emit('click-right');
  emitter.emit(EventEnum.CUSTOM_HEADER_BAR_RIGHT_CLICK);
};

watch(
  () => headerHeight.value,
  val => {
    appStore.setHeaderHeight(val);
  },
  { immediate: true }
);
</script>

<style lang="less" scoped>
.custom-header-bar {
  height: var(--header-height);
  line-height: var(--header-height);

  :deep(.van-nav-bar__content) {
    height: var(--header-height);
  }
}
</style>
